module.exports = __webpack_public_path__ + "img/78.7654dad0.jpg";